import { OrderSource } from '@zeus/shared';
import { CartStore, OrderType } from '../../app/(routes)/online-ordering/types';

export const CartInitialState: CartStore = {
  cart: {
    items: [],
    quantity: 0,
    orderedQuantity: 0,
    totalBill: 0,
    actualPrice: 0,
    discountedPrice: 0,
    totalTax: 0,
    tipAmount: 0,
    tipPercentage: 0,
    platformFee: 0,
    deliveryFeeInDollars: 0,
    deliveryPickupDate: '', // Format: YYYY-MM-DD (e.g., "2026-02-10")
    address: '',
    apartment: '',
    city: '',
    state: '',
    street: '',
    zipCode: 0,
    latitude: 0,
    longitude: 0,
    estimatedTimeSlotId: 0,
    restaurantId: 0,
    businessId: 0,
    restaurantName: '',
    customerUsername: '',
    order_type: OrderType.Takeaway,
    orderSource: OrderSource.Website,
    includeUtensils: false,
    note: '',
    guestSessionId: '',
    itemOutStock: false,
    modifierOutStock: false,
    showOutStockError: false,
  },
  cartOptions: {
    selectedCartItem: 0,
    isCartLoading: false,
    isCartUpdated: false,
    isCartEnabled: false,
  },
};
